import React from 'react';
import { SkeletonComponent } from '@design-system';

export const GenericProductSkeleton: React.FC = () => {
    return (
        <div style={{ marginTop: '97px' }}>
            {[...Array(6)].map((_, index) => (
                <SkeletonComponent
                    key={index}
                    count={1}
                    style={{
                        height: '109px',
                        width: 'calc(100% - 32px)',
                        margin: '-2px auto',
                        borderRadius: '12px',
                        display: 'block'
                    }}
                />
            ))}
        </div>
    );
};
